import type { ThemeAppearance } from '@atlaskit/lozenge';

// This mapping is copied from Jira FE:
// https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/jira/src/packages/issue/status-theming/src/statusCategoryToThemeMap.tsx
//
// If you are going to change this, please check the Jira FE mapping first to make sure they are in sync.
//
// It uses the statusCategoryId field from GQL to map to the corresponding Atlaskit lozenge appearance

const STATUS_THEME_DEFAULT = 'default';
const STATUS_THEME_SUCCESS = 'success';
const STATUS_THEME_IN_PROGRESS = 'inprogress';

export const statusCategoryToThemeMap: Record<string, ThemeAppearance> = {
	'1': STATUS_THEME_DEFAULT,
	'2': STATUS_THEME_DEFAULT,
	'3': STATUS_THEME_SUCCESS,
	'4': STATUS_THEME_IN_PROGRESS,
};